import {
  FETCH_CROP_DETAILS_SUCCESS,
  FETCH_CROP_DETAILS_LOADING,
  FETCH_CROP_DETAILS_ERROR,
  FETCH_CROPS_CACHE_SUCCESS
} from '../actions/types';

const mergeListIntoCache = (cache, cropsList) =>
  (cropsList || []).reduce(
    (acc, crop) => {
      acc[crop.id] = crop;
      return acc;
    },
    { ...cache }
  );

export const initialState = {
  loading: false,
  error: null,
  data: [],
  // id -> crop map accumulated across all fetch scopes, used for display
  // resolution; pickers keep reading the scoped `data` list
  cache: {}
};

export const crops = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CROP_DETAILS_LOADING:
      return {
        ...initialState,
        cache: state.cache || {},
        loading: true
      };
    case FETCH_CROP_DETAILS_SUCCESS:
      return {
        ...initialState,
        cache: { ...state.cache, ...action.payload?.entities?.crops },
        data: action.payload
      };
    case FETCH_CROP_DETAILS_ERROR:
      return {
        ...initialState,
        cache: state.cache || {},
        error: action.error
      };
    case FETCH_CROPS_CACHE_SUCCESS: {
      // keep the state identity when nothing new arrives so cache-dependent
      // effects don't re-trigger in a loop
      const cache = state.cache || {};
      const hasNewEntries = (action.payload || []).some((crop) => {
        if (!crop?.id) {
          return false;
        }
        const cached = cache[crop.id];
        return (
          !cached ||
          cached.updated_at !== crop.updated_at ||
          cached.name !== crop.name ||
          cached.wk_slug !== crop.wk_slug
        );
      });
      if (!hasNewEntries) {
        return state;
      }
      return {
        ...state,
        cache: mergeListIntoCache(cache, action.payload)
      };
    }
    default:
      return state;
  }
};
